<div class="popup-container">
  <div class="header d-flex align-items-center justify-content-center">
    <h2 i18n="@@payment-popup.enter-card-details">
      {{ headerText }}
    </h2>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="49"
      viewBox="0 0 49 49"
      fill="none"
      (click)="closeModal()"
    >
      <path
        d="M32.5938 18.9377C32.7355 18.7999 32.8486 18.6347 32.9267 18.452C33.0048 18.2693 33.0463 18.0726 33.0487 17.8735C33.0511 17.6743 33.0144 17.4766 32.9407 17.292C32.8671 17.1074 32.758 16.9395 32.6197 16.7982C32.4814 16.6569 32.3168 16.5449 32.1355 16.4688C31.9541 16.3927 31.7596 16.3541 31.5634 16.3551C31.3672 16.3561 31.1731 16.3968 30.9925 16.4747C30.8119 16.5527 30.6484 16.6663 30.5116 16.8091L24.5699 22.8003L18.667 16.7716C18.5322 16.6238 18.3694 16.5051 18.1883 16.4226C18.0073 16.34 17.8117 16.2953 17.6133 16.2911C17.4149 16.2869 17.2177 16.3234 17.0334 16.3982C16.8492 16.4731 16.6817 16.5848 16.5409 16.7268C16.4001 16.8688 16.289 17.0381 16.2141 17.2247C16.1392 17.4112 16.102 17.6112 16.1049 17.8126C16.1078 18.014 16.1506 18.2128 16.2308 18.397C16.311 18.5813 16.427 18.7472 16.5718 18.885L22.4707 24.9157L16.5309 30.907C16.269 31.1905 16.1257 31.5661 16.1313 31.9547C16.1368 32.3434 16.2908 32.7146 16.5607 32.9903C16.8307 33.266 17.1955 33.4246 17.5783 33.4326C17.9612 33.4407 18.3322 33.2976 18.6131 33.0336L24.5568 27.0423L30.4597 33.073C30.739 33.3389 31.1091 33.4843 31.492 33.4786C31.8749 33.473 32.2407 33.3167 32.5123 33.0428C32.7839 32.7688 32.9402 32.3985 32.9481 32.0099C32.9561 31.6214 32.8151 31.2448 32.5549 30.9596L26.656 24.929L32.5938 18.9377Z"
        fill="black"
      />
    </svg>
  </div>
  <div id="tz-checkout"></div>
  <div class="d-flex justify-content-center">
    @if (showTopupButton) {
      <button
        class="btn wallet-btn"
        (click)="topUpBalance()"
        type="button"
        i18n="@@wallet-topup"
      >
        TOP UP MY WALLET
      </button>
    }
    @if (showRedirectButton) {
      <button
        class="btn wallet-btn-ok"
        (click)="redirectUser()"
        [disabled]="isLoading"
        type="button"
        i18n="@@wallet.ok"
      >
        OK
      </button>
    }
  </div>
</div>
